import InputLabel from "@/Components/InputLabel";
import TextInput from "@/Components/TextInput";
import InputError from "@/Components/InputError";
import Checkbox from "@/Components/Checkbox";
import DatePicker from "@/Atoms/Date/DatePicker";
import PlaceSelect, { PlaceSelectProp } from "@/Atoms/Select/PlaceSelect";
import { useRef } from "react";

export type PersonFieldsProps = {
  first_name?: string
  last_name?: string
  nickname?: string
  birth_date?: string
  birth_date_hide?: boolean
  birth_place: PlaceSelectProp
  birth_place_hide?: boolean
  deceased_date?: string
  deceased_date_hide?: boolean
  deceased_place: PlaceSelectProp
  deceased_place_hide?: boolean
  gender: string
}
export default (
  {
    data,
    setData,
    errors,
    is_main,
    canCreate,
  }: {
    data: PersonFieldsProps,
    setData: (key: string, value: any) => void,
    errors: any,
    is_main: boolean,
    canCreate: boolean,
  }) => {

  const birthPlaceRef = useRef<HTMLDivElement>(null);
  const deceasedPlaceRef = useRef<HTMLDivElement>(null);
  return <div>
    <div className={'grid grid-cols-1  md:grid-cols-2 gap-6'}>
      <div>
        <InputLabel htmlFor="first_name" value="Voornaam" required data-testid={'first_name'} />
        <TextInput
          id="first_name"
          value={data.first_name ?? ''}
          onChange={(e) => setData('first_name', e.target.value)}
          fullWidth
        />
        <InputError message={errors.first_name} className="mt-2" />
      </div>

      <div>
        <InputLabel htmlFor="last_name" value="Achternaam" required data-testid={'last_name'} />
        <TextInput
          id="last_name"
          value={data.last_name ?? ''}
          onChange={(e) => setData('last_name', e.target.value)}
          fullWidth
        />
        <InputError message={errors.last_name} className="mt-2" />
      </div>

      <div>
        <InputLabel
          htmlFor="birth_date"
          value="Geboortedatum"
          required={is_main}
          data-testid={'birth_date'}
        />
        <DatePicker
          id="birth_date"
          name="birth_date"
          value={data.birth_date ?? ''}
          onChangeString={(date) => setData('birth_date', date)}
          className={'!block'}
        />

        <InputError message={errors.birth_date} className="mt-2" />
        <Checkbox
          id={'birth_date_hide'}
          checked={data.birth_date_hide ?? false}
          onChange={(e) => setData('birth_date_hide', e.target.checked)}
        /> <InputLabel htmlFor="birth_date_hide" value=" Niet online tonen" data-testid={'birth_date_hide'} />
      </div>
      <div>
        <InputLabel htmlFor="birth_place" value="Geboorteplaats" required={is_main} data-testid={'birth_place'} />
        <PlaceSelect
          id="birth_place"
          ref={birthPlaceRef}
          value={data.birth_place ?? ''}
          onChange={(place: any) => setData('birth_place', place)}
          canCreate={canCreate}
        />
        <InputError message={errors.birth_place} className="mt-2" />
        <Checkbox
          id={'birth_place_hide'}
          checked={data.birth_place_hide ?? false}
          onChange={(e) => setData('birth_place_hide', e.target.checked)}
        /> <InputLabel htmlFor="birth_place_hide" value=" Niet online tonen" data-testid={'birth_place_hide'} />
      </div>
      <div>
        <InputLabel htmlFor="deceased_date" value="Overleden op" required data-testid={'deceased_date'} />
        <DatePicker
          id="deceased_date"
          name={'deceased_date'}
          value={data.deceased_date ?? ''}
          onChangeString={(date) => setData('deceased_date', date)}
          className={'!block'}
        />
        <InputError message={errors.deceased_date} className="mt-2" />
        <Checkbox
          id={'deceased_date_hide'}
          checked={data.deceased_date_hide ?? false}
          onChange={(e) => setData('deceased_date_hide', e.target.checked)}
        /> <InputLabel htmlFor="deceased_date_hide" value=" Niet online tonen" data-testid={'deceased_date_hide'} />
      </div>
      <div>
        <InputLabel htmlFor="deceased_place" value="Overleden te" required data-testid={'deceased_place'} />
        <PlaceSelect
          id="deceased_place"
          ref={deceasedPlaceRef}
          value={data.deceased_place ?? ''}
          onChange={(place: any) => setData('deceased_place', place)}
          canCreate={canCreate}
        />
        <InputError message={errors.deceased_place} className="mt-2" />
        <Checkbox
          id={'deceased_place_hide'}
          checked={data.deceased_place_hide ?? false}
          onChange={(e) => setData('deceased_place_hide', e.target.checked)}
        /> <InputLabel htmlFor="deceased_place_hide" value=" Niet online tonen" data-testid={'deceased_place_hide'} />
      </div>

    </div>
    <div className={'my-5'}><span className={'color-primary font-bold'}>* </span>
      {is_main ? 'Geboorte- en overlijdens' : 'Overlijdens'}datum en plaats zijn verplicht om in te vullen, maar je kunt
      ervoor kiezen deze niet op de rouwpagina te tonen.
    </div>
  </div>
}
